// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"949":"2ea55cbb","975":"6290ddbf"}[chunkId] + ".chunk.js";
};